export const ULP_API = '/api/web/auth/login_by_sso';

export const LOCAL_API = '/sso-local-dev';

export const LANE_API = '/api/external/ulp';

export const prodOrigin = 'https://ulp.sheincorp.cn';

export const laneOrigin = 'https://lane.sheintee.cn/api/external/ulp';

export const localOrigin = 'https://ulp-dev01.sheincorp.cn';

export const testOrigin = 'https://ulp-test01.sheincorp.cn';

export const localList = ['localhost', '127.0.0.1'];

export const laneDomain = '.sheintee.cn';

export const APMINFO = {
  ID: 'df79fed4-1900-5294-90a2-a4f5b68f950f',
  LABEL: 'login-by-sso',
  ULP_EXPIRED_LABEL: 'login-by-sso-when-ulp-expired',
  EXPIRED_TIME: 1000 * 10,
};
